import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ProcessCode } from './models/ProcessCode';

@Injectable({ providedIn: 'root' })
export class ProcessCodeService {
  private http = inject(HttpClient);

  constructor() {}

  getProcessCodes(dealerId: string): Observable<ProcessCode[]> {
    // Adjust the URL if needed
    // const url = `${environment.backOfficeUrl}${environment.serviceUris.getPlantProcessCode}`;
    const url = `${environment.backOfficeUrl}${environment.serviceUris.getPlantProcessCode.replace('{dealerId}', dealerId)}`;
    return this.http.get<ProcessCode[]>(url);
  }
}
